import { MultiSelect } from "@appretio/ui-kit";
import { useMemo } from "react";
import type { StoreStatusOption } from "../../hooks/useFetchStoreStatusOptions";

/** Props for the store status multi-select filter dropdown. */
interface StoreStatusFilterProps {
  /** Available store status options to display. */
  options: StoreStatusOption[];
  /** Currently selected status values. */
  selected: string[];
  /** Callback when the selection changes. */
  onChange: (statuses: string[]) => void;
  /** Whether the options are still loading. */
  isLoading: boolean;
  /** Statuses that are relevant given the current sales_location selection. */
  relevantStatuses?: string[];
}

export function StoreStatusFilter({
  options,
  selected,
  onChange,
  isLoading,
  relevantStatuses
}: StoreStatusFilterProps) {
  const selectOptions = useMemo(() => {
    const relevantSet =
      relevantStatuses && relevantStatuses.length > 0
        ? new Set(relevantStatuses)
        : null;

    return options.map((opt) => ({
      label: opt.status,
      value: opt.status,
      relevant: relevantSet ? relevantSet.has(opt.status) : true
    }));
  }, [options, relevantStatuses]);

  return (
    <MultiSelect
      loading={isLoading}
      label="Store Status"
      options={selectOptions}
      value={selected}
      onChange={onChange}
    />
  );
}
